import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import MuiCardMedia, { CardMediaProps } from '@material-ui/core/CardMedia';

const CardMedia: React.FC<CardMediaProps> = withStyles((theme) => ({
  root: {
    position: 'relative',
    overflow: 'hidden',
    zIndex: 10,
    borderRadius: 4,
    paddingTop: '100%',
  },
}))(MuiCardMedia);

export default CardMedia;
